import React, {FC} from 'react';
import PageHeader from '../../../components/PageHeader';
import useMe from '../../../hooks/useMe';
import BookingRequestFollowUpModal from '../components/BookingRequestFollowUpModal';
import MedicalCareSearch from '../components/MedicalCareSearch';
import MobilePageContainer from '../components/MobilePageContainer';
import MyAppointments from '../components/MyAppointments';
import MyProviders from '../components/MyProviders';
import Page from '../components/Page';
import PendingBillingStatements from '../components/PendingBillingStatements';
import RecentPayments from '../components/RecentPayments';
import UnredeemedVouchers from '../components/UnredeemedVouchers';
import {VStack} from 'components/ui/chakra';

const PatientPortalHomeScreen: FC = () => {
	const {me} = useMe();

	if (!me) return null;

	return (
		<Page overflow='auto'>
			<MobilePageContainer>
				<VStack w='full' spacing={8} alignItems='flex-start'>
					<PageHeader
						description='Search for care, review billing, and keep upcoming appointments in one place.'
						eyebrow='Patient Portal'
						heading={`Welcome back${me.first_name ? `, ${me.first_name}` : ''}`}
						w='full'
					/>
					<RecentPayments />
					<MedicalCareSearch />
					<PendingBillingStatements />
					<UnredeemedVouchers />
					<MyAppointments />
					<MyProviders />
					<BookingRequestFollowUpModal />
				</VStack>
			</MobilePageContainer>
		</Page>
	);
};

export default PatientPortalHomeScreen;
